/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExportTabsCSV200Response
 */
export interface ExportTabsCSV200Response {
    /**
     * 
     * @type {string}
     * @memberof ExportTabsCSV200Response
     */
    status: ExportTabsCSV200ResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ExportTabsCSV200Response
     */
    data?: string;
}


/**
 * @export
 */
export const ExportTabsCSV200ResponseStatusEnum = {
    Success: 'success',
    Background: 'background'
} as const;
export type ExportTabsCSV200ResponseStatusEnum = typeof ExportTabsCSV200ResponseStatusEnum[keyof typeof ExportTabsCSV200ResponseStatusEnum];


/**
 * Check if a given object implements the ExportTabsCSV200Response interface.
 */
export function instanceOfExportTabsCSV200Response(value: object): value is ExportTabsCSV200Response {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function ExportTabsCSV200ResponseFromJSON(json: any): ExportTabsCSV200Response {
    return ExportTabsCSV200ResponseFromJSONTyped(json, false);
}

export function ExportTabsCSV200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExportTabsCSV200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'data': json['data'] == null ? undefined : json['data'],
    };
}

export function ExportTabsCSV200ResponseToJSON(json: any): ExportTabsCSV200Response {
    return ExportTabsCSV200ResponseToJSONTyped(json, false);
}

export function ExportTabsCSV200ResponseToJSONTyped(value?: ExportTabsCSV200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'data': value['data'],
    };
}

